<template>
  <nav>
    <v-toolbar app class="primary">
      <v-toolbar-title class="text-uppercase white--text">
        <span class="font-weight-white">Store</span>
        <span>manager</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <Login/>
      <Signup/>
    </v-toolbar>
  </nav>
</template>

<script>
import Login from "./Login";
import Signup from "./Signup";
export default {
  components: { Login, Signup },
  data() {
    return {
      drawer: true,
      links: [
        { icon: "account_box", text: "About us", route: "/about" },
        { icon: "store", text: "Pricing", route: "/pricing" },
        { icon: "settings", text: "Pricing", route: "/pricing" }
      ]
    };
  }
};
</script>
